import gql from "graphql-tag";

const ORDERS_BY_STAKEHOLDER_QUERY = gql`
    query OrdersByStakeholder($state: String, $lookupId: String, $orderNumber: String, $showAll:Boolean){
    ordersByStakeholder(state: $state, lookupId: $lookupId, orderNumber: $orderNumber, showAll: $showAll) {
        id
        state
        description
        addressTo
        fflName
        attention {
            person
            city
            state
            zip
        }
        orderNumber
        placedOrderNumber
        eventId
        chapterId
        address {
            name
            street1
            street2
            city
            region
            postal_code
            country
            phone
        }
        createdAt
        updatedAt
        items {
            quantity
            product{
                id
                name
                description
                code
                cost
                image{
                    original
                    thumbnail
                    zoom
                }
                maxQty
                stepQty
                startDate
                endDate
                createdAt
                updatedAt
            }
        }
        stakeholders {
            name
            email
            constituentId
            role
            lookupId
        }
    }
    }
`;
export default ORDERS_BY_STAKEHOLDER_QUERY;